// extracted by mini-css-extract-plugin
export default {"livrosPage":"LivrosPage_livrosPage__DIAcx","livrosList":"LivrosPage_livrosList__Ku+73"};